export default "__VITE_ASSET__B$LiuLZk__"